<template>
  <div class="wrap-sponsor">
    <b-container>
      <div
        v-for="(sponsor, i) in sponsors"
        :key="i"
        class="box"

      >
        <div class="box-title">
          <div></div>
          <h2>
            {{ sponsor.title }} <span>by</span>
          </h2>
        </div>

        <div
          v-if="sponsor.title === 'Sponsored'"
          class="box-main-sponsor"
        >
          <b-row v-if="sponsor.gold.length !== 0" class="gold">
            <b-col
              v-for="(data, i) in sponsor.gold"
              :key="i"
              cols="auto"
              class="box-logo-sponsor"
            >
              <a :href="data.link" target="_blank"><img :src="`https://admanawards.com/storage/app/img/sponsor/${data.sponsor_picture}`"></a>
            </b-col>
          </b-row>

          <b-row v-if="sponsor.silver.length !== 0" class="silver">
            <b-col
              v-for="(data, i) in sponsor.silver"
              :key="i"
              cols="auto"
              class="box-logo-sponsor"
            >
               <a :href="data.link" target="_blank"><img :src="`https://admanawards.com/storage/app/img/sponsor/${data.sponsor_picture}`"></a>
            </b-col>
          </b-row>

          <b-row v-if="sponsor.bronze.length !== 0" class="bronze">
            <b-col
              v-for="(data, i) in sponsor.bronze"
              :key="i"
              cols="auto"
              class="box-logo-sponsor"
            >
               <a :href="data.link" target="_blank"><img :src="`https://admanawards.com/storage/app/img/sponsor/${data.sponsor_picture}`"></a>
            </b-col>
          </b-row>
        </div>

        <div
          v-else
          class="box-sub-sponsor"
        >
          <b-row>
            <b-col
              v-for="(data, i) in sponsor.data"
              :key="i"
              cols="auto"
              class="box-logo-sponsor"
            >
                <a :href="data.link" target="_blank"><img
                :src="`https://admanawards.com/storage/app/img/sponsor/${data.sponsor_picture}`"
                :style="[ sponsor.title === 'Media Sponsor' ? { height: '70px' } : {} ]"
              ></a>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      sponsors: {}
    }
  },

  computed: {
    ...mapState({
      sponsorsRaw: state => state.sponsor.data
    })
  },

  methods: {
    sponsorCate () {
      const sponsorsRaw = this.sponsorsRaw

      const gold = sponsorsRaw.filter(sponsor =>
        sponsor.category[0].sponsor_category === 'Sponsor Gold'
      )

      const silver = sponsorsRaw.filter(sponsor =>
        sponsor.category[0].sponsor_category === 'Sponsor Silver'
      )

      const bronze = sponsorsRaw.filter(sponsor =>
        sponsor.category[0].sponsor_category === 'Sponsor Bronze'
      )

      const mediaSponser = sponsorsRaw.filter(sponsor =>
        sponsor.category[0].sponsor_category === 'Media Sponsor'
      )

      const supported = sponsorsRaw.filter(sponsor =>
        sponsor.category[0].sponsor_category === 'Supported'
      )

      const mediaPartner = sponsorsRaw.filter(sponsor =>
        sponsor.category[0].sponsor_category === 'Media Partner'
      )

      this.sponsors = {
        main: {
          title: 'Sponsored',
          gold: gold,
          silver: silver,
          bronze: bronze
        },
        media_sponser: {
          title: 'Media Sponsor',
          data: mediaSponser
        },
        supported: {
          title: 'Supported',
          data: supported
        },
        media_partner: {
          title: 'Media Partner',
          data: mediaPartner
        }
      }
    }
  },

  created () {
    if (this.sponsorsRaw === null) {
      this.$store.dispatch('sponsor/get')
    } else {
      this.sponsorCate()
    }
  },

  watch: {
    sponsorsRaw () {
      this.sponsorCate()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.wrap-sponsor {
  .container {
    .box {
      margin-top: 16px;
      border-bottom: 1px solid #ADADAD;

      .box-title {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        div {
          width: 10px;
          height: 10px;
          background-color: $active;
        }

        h2 {
          margin-left: 12px;

          span {
            opacity: 0.5;
          }
        }
      }

      .box-main-sponsor, .box-sub-sponsor {
        .row {
          padding: 12px 0;
          border-bottom: 1px solid #ADADAD;

          .box-logo-sponsor {

            @media only screen and (min-width: $break-m) {
              display: block;
              margin: 4px 4px;
            }

            img {
              height: 100%;
            }
          }
        }

        .gold {
          border-color: #F7DC63;

          .box-logo-sponsor {
            padding: 0 4px;
            height: 100px;
          }
        }

        .silver {
          border-color: #C2BAA6;

          .box-logo-sponsor {
            padding: 0 4px;
            height: 90px;
          }
        }

        .bronze {
          border-color: #F4B04D;

          .box-logo-sponsor {
            padding: 0 4px;
            height: 70px;
          }
        }
      }

      .box-sub-sponsor {
        .row {
          border: none;

          .box-logo-sponsor {
            display: block;
            margin: 4px 4px;
            padding: 0;
            height: 60px;
          }
        }
      }
    }

    .box-hide {
      display: none;
    }

    .box:last-child {
      border: none;
    }

    .box:first-child {
      border: none;
    }
  }
}
</style>
